const designSystemElevations = [
    'none',
    '0px 2px 6px rgb(1 71 79 / 0.32)',
    '0px 4px 6px rgb(1 71 79 / 0.32)',
    '0px 8px 16px rgb(1 71 79 / 0.32)',
    '0px 16px 24px rgb(1 71 79 / 0.32)',
];
const elevations = [...designSystemElevations];

export { elevations };
//# sourceMappingURL=elevations.js.map
